import { NgModule } from '@angular/core';

import { RouterModule, Routes } from '@angular/router';
import { ConfirmationComponent } from './confirmation.component';
import { AccommodationComponent } from './accommodation/accommodation.component';
import { ConferenceComponent } from './conference/conference.component';
import { AccommodationGuard } from './services/accommodation.guard';
import { ConferenceGuard } from './services/conference.guard';

const routes: Routes = [
  {
    path: 'confirmations',
    component: ConfirmationComponent,
    children: [
      {
        path: 'accommodation',
        component: AccommodationComponent,
        canActivate: [AccommodationGuard]
      },
      {
        path: 'conference',
        component: ConferenceComponent,
        canActivate: [ConferenceGuard]
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ConfirmationRoutingModule {}



// WEBPACK FOOTER //
// /Users/abassey/side-proj/emp21-new/src/app/confirmation/confirmation.routing.ts